import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import Highlighter from 'react-highlight-words';
import { SUBSCRIBER_ROLES } from '@constants';
import styles from './userAutocompleteOption.style';
import { HIGHLIGHT_STYLE } from '../constants';

const UserAutocompleteOption = ({
  autoCompleteProps,
  option,
  searchTerm,
  selectedSubscription,
}) => {
  const user = option.user || {};
  const firstName = user.firstName || '';
  const lastName = user.lastName || '';
  const email = user.email || '';
  const phoneNumber = user.phoneNumber || '';

  const roleMapping = {
    [SUBSCRIBER_ROLES.owner.value]: {
      text: SUBSCRIBER_ROLES.owner.text,
      styles: styles.roleChipOwner,
    },
    [SUBSCRIBER_ROLES.driver.value]: {
      text: SUBSCRIBER_ROLES.driver.text,
      styles: styles.roleChipDriver,
    },
    [SUBSCRIBER_ROLES.admin.value]: {
      text: SUBSCRIBER_ROLES.admin.text,
      styles: styles.roleChipAdmin,
    },
  };

  const userRoleValue = user?.subscriptions?.[0]?.role;
  const roleInfo = roleMapping[userRoleValue];
  const role = roleInfo?.text || null;
  const roleStyles = roleInfo?.styles || null;

  const hasDriverStatus = typeof option.activeDriver === 'boolean';
  const isActiveDriver = option.activeDriver === true;

  const searchWords = searchTerm ? [searchTerm] : [];

  return (
    <Box
      component="li"
      {...autoCompleteProps}
      key={option.value || 'key'}
      sx={styles.container}
    >
      {!!selectedSubscription && hasDriverStatus && (
        <Tooltip
          title={isActiveDriver ? 'Active driver' : 'Inactive driver'}
          arrow
        >
          <Box
            sx={
              isActiveDriver ? styles.activeDriverDot : styles.inactiveDriverDot
            }
          />
        </Tooltip>
      )}
      <Box sx={styles.name}>
        <Highlighter
          highlightStyle={HIGHLIGHT_STYLE}
          searchWords={searchWords}
          autoEscape
          textToHighlight={firstName}
        />
      </Box>
      <Box sx={styles.name}>
        <Highlighter
          highlightStyle={HIGHLIGHT_STYLE}
          searchWords={searchWords}
          autoEscape
          textToHighlight={lastName}
        />
      </Box>
      <Box sx={styles.text}>-</Box>
      <Box sx={styles.text}>
        <Highlighter
          highlightStyle={HIGHLIGHT_STYLE}
          searchWords={searchWords}
          autoEscape
          textToHighlight={email}
        />
      </Box>
      {phoneNumber && (
        <>
          <Box sx={styles.text}>-</Box>
          <Box sx={styles.text}>
            <Highlighter
              highlightStyle={HIGHLIGHT_STYLE}
              searchWords={searchWords}
              autoEscape
              textToHighlight={phoneNumber}
            />
          </Box>
        </>
      )}
      {!!selectedSubscription && role && (
        <>
          <Box sx={styles.text}>-</Box>
          <Chip label={role} size="small" variant="outlined" sx={roleStyles} />
        </>
      )}
    </Box>
  );
};

export default UserAutocompleteOption;
